import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReleaseNote } from 'src/app/shared/models/release-note';
import { environment } from 'src/environments/environment';
import { SaveResponse } from '../../models/save-response';

@Injectable({
    providedIn: 'root'
})
export class ReleaseNotesApiService {
    baseUrl: string = environment.apiUrl;
    releaseNotesUrlSuffix = 'v3/release_notes';

    constructor(private httpClient: HttpClient) {}

    getReleaseNotes(): Observable<ReleaseNote[]> {
        const idSuffix = this.releaseNotesUrlSuffix;
        return this.httpClient.get<ReleaseNote[]>(`${this.baseUrl}${idSuffix}`);
    }

    getReleaseNote(releaseNoteId: number): Observable<ReleaseNote> {
        return this.httpClient.get<ReleaseNote>(`${this.baseUrl}${this.releaseNotesUrlSuffix}/${releaseNoteId}`);
    }

    addReleaseNote(data: ReleaseNote): Observable<ReleaseNote> {
        return this.httpClient.post<ReleaseNote>(`${this.baseUrl}${this.releaseNotesUrlSuffix}`, data);
    }

    updateReleaseNote(releaseNoteId: number, data: ReleaseNote): Observable<SaveResponse> {
        return this.httpClient.put<SaveResponse>(`${this.baseUrl}${this.releaseNotesUrlSuffix}/${releaseNoteId}`, data);
    }

    deleteReleaseNote(releaseNoteId: number): Observable<void> {
        const idSuffix = `${this.releaseNotesUrlSuffix}/${releaseNoteId}`;
        return this.httpClient.delete<void>(`${this.baseUrl}${idSuffix}`);
    }
}
